(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-entry-content-template"]) return;
  try {
    
  
  //  $(document).ready(function () {
  //   if ($("#shopify-section-homepage-entry-content-template").length) {
  //     $("div.page-wrapper").addClass("reset");
  //   }
  // });
  
  $(document).ready(function () {
    (function () {
      if ($("#shopify-section-homepage-entry-content-template").length) {
        $("div.page-wrapper").addClass("reset");
      }
      })();
  });

  } catch(e) { console.error(e); }
})();
})();
